import React, { Component, Fragment } from 'react';
import styles from './Footer.scss';
import classNames from 'classnames/bind';
import InfoModal from './InfoModal';

const cx = classNames.bind(styles);

class Footer extends Component {
	state = {
		InfoVisible: false,
	};

	render() {
	const { InfoVisible } = this.state;

return(
	<Fragment>
	<footer className = {cx('footer')}>
		<div className = {cx('footer-content')}>
			{/* <Link to = "/" className={cx('logo')}>YUJIN MALL</Link> */}
			<table>
				<thead></thead>
					<tbody>
					<tr>
						<td>
						<div className = {cx('detail')}>
							<p><strong>㈜유진에스앤에이</strong></p>
							<p>대표이사 : 박정호  |  05112) 서울특별시 광진구 뚝섬로 698   </p>
							<p>통신판매업신고 : 제 2024-서울광진-1575호  |  사업자등록번호 : 204-81-95563</p>
							<p>전화 : 02-929-8675, 02-921-3775 팩스 : 02-458-7855</p>
							<p>COPYRIGHT © 2020 YUJIN S&A ALL RIGHTS RESERVED</p>
							<p id="copyright">
							{/* <span role="img" aria-label='point'>👉</span> */}
							</p>
						</div>
						</td>
						<td>
						<div className = {cx('detail')}>
						<ul>
							<li onClick = {()=>this.setState({InfoVisible: true})}><p id='information2'>개인정보처리방침</p></li>
						</ul>	
							<p id='information'>고객센터</p>
							<p id='information'>02-929-8675, 02-921-3775</p>
							<p id='information'>AM 09:00 ~ PM 18:00 (토,일, 공휴일 휴무)</p>
							<p id='information'>점심시간 PM 12:00 ~ PM 13:00</p>
						</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</footer>

	<InfoModal
		modalOpen={InfoVisible}
		modalClose={()=>this.setState({InfoVisible: false})}
	/>
	</Fragment>
	);
	}
}
export default Footer;
